import React from 'react'

import { UserInfoSettings } from 'src/features/UserCurrency'
import SettingToggleTheme from 'src/features/SettingToggleTheme'
import AppToggleLanguage from 'src/features/SettingToggleLanguage'
import { MakePdfInfoCar } from 'src/features/MakePdfInfoCar'
import { ColorThemeSelect } from 'src/features/ColorThemeSelect'
import Container from 'src/components/Container'
import AppBreadcrumb from 'src/components/AppBreadcrumb'

import { useSetting } from './useSetting'

const Setting = (): JSX.Element => {
  const { breadcrumbItems } = useSetting()

  return (
    <Container>
      <AppBreadcrumb items={breadcrumbItems} />
      <div className="mt-8">
        <AppToggleLanguage />
        <SettingToggleTheme />
        <ColorThemeSelect />
        <UserInfoSettings />
        <MakePdfInfoCar />
      </div>
    </Container>
  )
}

export default Setting
